export const MIXPANEL_EVENTS = {
  // App session
  SESSION_STARTED: 'Session Started',
  SESSION_ENDED: 'Session Ended',

  // Tour
  TOUR_OPENED: 'Tour Opened',
  TOUR_STARTED: 'Tour Started',
  TOUR_STEP_COMPLETED: 'Tour Step Completed',
  TOUR_COMPLETED: 'Tour Completed',
  TOUR_SKIPPED: 'Tour Skipped',

  // Search
  SEARCH: 'Search',
  POPULAR_SEARCH: 'Popular Search',
  RECENT_SEARCH_CLICKED: 'Recent Search Clicked',
  SEARCH_RESULTS_LOADED: 'Search Results Loaded',
  SEARCH_RESULT_CLICKED: 'Search Result Clicked',
  SEARCH_SUGGESTION_CLICKED: 'Search Suggestion Clicked',

  // Info popovers
  INFO_POPOVER_CLICKED: 'Info Popover Clicked',
  INFO_POPOVER_CLOSED: 'Info Popover Closed',
  LEARN_MORE_INFO_POPOVER_CLICKED: 'Learn More Info Popover Clicked',

  // Impact Assessment
  IMPACT_ASSESSMENT_TABLE_SORTED: 'Impact Assessment Table Sorted',
  IMPACT_ASSESSMENT_METHOD_SELECTED: 'Impact Assessment Method Selected',
  IMPACT_ASSESSMENT_TAB_VIEW_TOGGLED: 'Impact Assessment Tab View Toggled',
  LCIA_METHOD_INFO_LINK_CLICKED: 'LCIA Method Info Link Clicked',
  VIEW_LCIA_METHOD_INFO_CLICKED: 'View LCIA Method Info Clicked',
  VIEW_LCIA_METHOD_INFO_CLOSED: 'View LCIA Method Info Closed',
  DIRECT_CONTRIBUTION_BAR_NAVIGATION_TRIGGERED: 'Direct Contribution Bar Navigation Triggered',
  DIRECT_CONTRIBUTION_BAR_CHART_SHOW_MORE_CLICKED: 'Direct Contribution Bar Chart Show More Clicked',
  IMPACT_SCORES_EXPORTED: 'Impact Scores Exported',
  IMPACT_ASSESSMENT_CATEGORY_EXPANDED: 'Impact Assessment Category Expanded',
  IMPACT_ASSESSMENT_GRAPH_VIEW_SELECTED: 'Impact Assessment Graph View Selected',
  IMPACT_ASSESSMENT_TABLE_VIEW_SELECTED: 'Impact Assessment Table View Selected',
  DIRECT_CONTRIBUTION_SUPPLIER_LINK_CLICKED: 'Direct Contribution Supplier Link Clicked',
  DIRECT_CONTRIBUTION_IMPACT_VALUE_COPIED: 'Direct Contribution Impact Value Copied',

  // Dataset
  BREADCRUMB_HOME_CLICKED: 'Breadcrumb Home Clicked',
  COPY_DATASET_VALUE: 'Copy Dataset Value',
  COPY_SCORE_ON_SEARCH_RESULTS: 'Copy Score on Search Results',
  EXPORT_DATASET: 'Export Dataset',
  EXCHANGE_CLICKED: 'Exchange Clicked',
  CONSUMING_ACTIVITY_CLICKED: 'Consuming Activity Clicked',
  DATASET_HISTORY_USED: 'Dataset history used',
  DATASET_PAGE_SESSION: 'Dataset Page Session',

  // Related datasets
  DATASET_VIEW_RELATED_DATASET: 'Dataset - View Related Dataset',
  VIEW_RELATED_DROPDOWN_INFO_CLICKED: 'View Related Dropdown Info Clicked',
  VIEW_RELATED_DROPDOWN_CLOSED: 'View Related Dropdown Closed',
  CLICK_RELATED_DROPDOWN_INFO_LINK_CLICKED: 'Click Related Dropdown Info Link Clicked',

  // Landing / Explore
  EXPLORE_ALL_DATASETS: 'Explore all datasets',
  EXPLORE_BY_FILTER: 'Explore by filter',
  EXPLORE_SINGLE_DATASET: 'Explore single dataset',
  RECENTLY_VIEWED_DATASET: 'Recently viewed dataset',

  // Files / Downloads
  DOWNLOAD_FILE: 'Download file',
  DOWNLOAD_REPORT: 'Download report',

  // Flows
  FLOW_SEARCH_CLEARED: 'Flow Search Cleared',
  FLOW_SEARCH_BAR_CLICKED: 'Flow Search Bar Clicked',

  // Dataset comparison
  COMPARE_DATASET_ADDED: 'Compare Dataset Added',
  COMPARE_DATASET_REMOVED: 'Compare Dataset Removed',
  COMPARISON_STARTED: 'Comparison Started',
  COMPARISON_VIEWED: 'Comparison Viewed',
  COMPARISON_TAB_CHANGED: 'Comparison Tab Changed',
  COMPARISON_NO_IMPACT_DATA: 'Comparison No Impact Data Shown',
  COMPARISON_METHOD_SELECTED: 'Comparison LCIA Method Selected',
  COMPARISON_CONTRIBUTORS_VIEWED: 'Comparison Contributors Viewed',
  COMPARISON_COMMON_EXCHANGES_TOGGLED: 'Comparison Common Exchanges Only Toggled',
  COMPARISON_EXCHANGES_SORTED: 'Comparison Exchanges Sorted',
  COMPARISON_DATASET_LOAD_FAILED: 'Comparison Dataset Load Failed',
  COMPARISON_BLOCKED: 'Comparison Blocked',

  // Sidebar / Nav
  LOGO_CLICKED: 'Logo Clicked',
  KNOWLEDGE_BASE_BUTTON_CLICKED: 'Knowledge Base Button Clicked',
  SELECT_VERSION: 'Select Version',
  LOGIN_HEADER: 'Login (Header)',
  LOGIN_DATASET: 'Login (Dataset)',
  SIDENAV_REGISTER_CLICKED: 'sidenav_register_clicked',
  CONTACT_SALES_CLICKED: 'Contact Sales Clicked',

  // Legal & Privacy (legacy snake_case preserved intentionally)
  LEGAL_PRIVACY_DROPDOWN_OPENED: 'legal_privacy_dropdown_opened',
  LEGAL_PRIVACY_DROPDOWN_CLOSED: 'legal_privacy_dropdown_closed',
  LEGAL_PRIVACY_PRIVACY_POLICY_CLICKED: 'legal_privacy_privacy_policy_clicked',
  LEGAL_PRIVACY_EULA_CLICKED: 'legal_privacy_eula_clicked',
  LEGAL_PRIVACY_COOKIE_PREFERENCES_CLICKED: 'legal_privacy_cookie_preferences_clicked',

  // Announcement banner
  CONTEXTUAL_HELP_BANNER_CLICKED: 'Contextual Help Banner Clicked',
  CONTEXTUAL_HELP_BANNER_DISMISSED: 'Contextual Help Banner Dismissed',

  // Year in Review banner
  YEAR_IN_REVIEW_BANNER_CLICKED: 'Year in Review Banner Clicked',
  YEAR_IN_REVIEW_BANNER_DISMISSED: 'Year in Review Banner Dismissed',

  // API Launch banner
  API_LAUNCH_BANNER_CLICKED: 'API Launch Banner Clicked',
  API_LAUNCH_BANNER_DISMISSED: 'API Launch Banner Dismissed',

  // Questionnaire
  QUESTIONNAIRE_CARD_SHOWN: 'Questionnaire Card Shown',
  QUESTIONNAIRE_CARD_DISMISSED: 'Questionnaire Card Dismissed',
  QUESTIONNAIRE_STARTED: 'Questionnaire Started',
  QUESTIONNAIRE_STEP_VIEWED: 'Questionnaire Step Viewed',
  QUESTIONNAIRE_STEP_COMPLETED: 'Questionnaire Step Completed',
  QUESTIONNAIRE_BACK_CLICKED: 'Questionnaire Back Clicked',
  QUESTIONNAIRE_ABANDONED: 'Questionnaire Abandoned',
  QUESTIONNAIRE_COMPLETED: 'Questionnaire Completed',
} as const;
